import {
    Component,
    Input,
    OnInit,
    NgZone,
    OnDestroy,
    Output,
    EventEmitter,
    ViewChild,
    ElementRef,
    HostBinding
} from '@angular/core';
import {AuthenticationService} from '../../auth/_services/authentication.service';
import {ChatService} from "../chat.service";

import {PhoneService} from "../../service/phone.service";
import {PreloaderService} from "../../service/preloader.service";
import {Router} from "@angular/router";
import {BrowsersDetectionService} from "../../service/browsersDetection.service";
import {ChatFrameService} from "../../service/chatFrame.service";


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
    @Input()
    backLink;

    @Input()
    hideMenuBtn;

    @Input()
    isSticky;

    @Input()
    headerType;

    @Output() updateImage = new EventEmitter();

    logo = '../../../assets/images/default-person.png';

    @ViewChild('changeAvatarInput', {static: false}) 'changeAvatarInput': ElementRef;
    @HostBinding('class.is-sticky') sticky = false;

    constructor(private ngZone: NgZone,
        private authenticationService:AuthenticationService,
        private chatService: ChatService,
        private phoneService:PhoneService,
        private preloaderService:PreloaderService,
        private browsersDetection: BrowsersDetectionService,
        private chatFrameService: ChatFrameService,
        private router: Router
    ) {

    }

    ngOnInit() {
        this.sticky = this.isSticky;
        this.loadAvatar();

        this.phoneService.avatarChanged.subscribe((value: any) => this.loadAvatar());

    }

    getAvatar(){
        return this.logo;
    }

    loadAvatar(){
        this.preloaderService.show();

        this.chatService.getProfileAvatar().subscribe(data => {

            if(data.status){
                this.ngZone.run( () => {
                    this.logo = data.result;
                });
            }

            this.ngZone.run( () => {
                this.preloaderService.hide();
            });
        });
    }

    getBackLink() {
        if (this.isBackLink()) {
            return this.backLink;
        }

        return false;
    }

    isBackLink() {
        if (this.backLink && this.backLink != undefined) {
            return true;
        }

        return false;
    }

    isHeaderTypeBase() {
        return this.checkHeaderType('base');
    }

    isHeaderTypeProfile() {
        return this.checkHeaderType('profile');
    }

    isHeaderTypeChat() {
        return this.checkHeaderType('chat');
    }

    isHeaderTypeAbout() {
        return this.checkHeaderType('about');
    }

    checkHeaderType(type) {
        if (this.headerType && this.headerType != undefined) {
            if (this.headerType === type) {
                return true;
            }
        }
        return false;
    }

    goToPage(){
        let page = this.isHeaderTypeChat() ? '/about':'/profile';

        this.preloaderService.show();

        let $this = this;
        setTimeout(function () {
            $this.router.navigate([page]);
        },200);

    }

    goBack(){
        this.preloaderService.show();

        let $this = this;
        setTimeout(function () {
            $this.router.navigate([$this.backLink]);

            if ($this.isHeaderTypeChat()) {
                $this.chatFrameService.decreaseFrameHeight();
            }

        },200);
    }

    changeLogo() {
        if (this.browsersDetection.isAndroid()) {
            this.phoneService.setChangeAvatar();
        } else {
            this.changeAvatarInput.nativeElement.click();
        }
    }

    handleFileInput(files) {
        if (files) {
            this.updateImage.emit(files);
        }
    }
}
